import { AppBar, Backdrop, Box, Button, ButtonGroup, CircularProgress, Grid, IconButton, Paper, Stack, Toolbar, Tooltip, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import CheckLoading from "../../CheckLoading";
import { RetrieveImagesRequest, imagesSlice, retrieveImages, selectImages } from "../../../../redux/image/imagesSlice";
import { useSelector } from "react-redux";
import { LoadState, getBackendThumbnailUrl, getImageStatusColor } from "../../../../redux/common";
import { useAppDispatch } from "../../../../app/hooks";
import { PRIZA_THEME } from "../../../..";
import FragmentFullContent from "../../FragmentFullContent";
import { ModalImageDetail } from "../ModalImageDetail";
import { ImageSetAvatarRequest } from "../../../../redux/image/imageSetAvatar";
import RefreshIcon from "@mui/icons-material/Refresh";
import AddIcon from "@mui/icons-material/Add";
import RuleIcon from "@mui/icons-material/Rule";
import AddTaskIcon from "@mui/icons-material/AddTask";
import { ElementUploadImages } from "../ElementUploadImages";

// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CloseIcon from "@mui/icons-material/Close";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { ImageInfo } from "../../../../redux/image/imageSlice";
import { performaImageReview, selectImageReview } from "../../../../redux/image/imageReviewSlice";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { anyDirectPermission, ObjectTarget, PermissionId } from "../../../../app/permissions";
import { selectUser } from "../../../../redux/user/userSlice";

export interface ElementShowImagesProps {
    request: RetrieveImagesRequest,
    toolbar: {
      label?: React.ReactNode;
    }
    messages: {
      empty: string;
      error: string;
    }
    notStarted?: React.ReactNode;
    schoolId: string;
    canDelete?: boolean;
  }

export function ElementShowImages(props: ElementShowImagesProps) {
    const dispatch = useAppDispatch();

    const user = useSelector( selectUser );

    const [ selectedImage, setSelectedImage ] = useState( -1 );
    const [ isUpload, setIsUpload ] = useState( false );
    const [ reviewEnabled, setReviewEnabled ] = useState( false );
    const [ selecting, setSelecting ] = useState( false );
    const [ selectedList, setSelectedList ] = useState( [] as string[] );
    
    const isSm = useMediaQuery(PRIZA_THEME.breakpoints.up("sm"));
    const isMd = useMediaQuery(PRIZA_THEME.breakpoints.up("md"));
    const isLg = useMediaQuery(PRIZA_THEME.breakpoints.up("lg"));
    const isXl = useMediaQuery(PRIZA_THEME.breakpoints.up("xl"));

    // const columnCount =
    //     isXl ? 12 :
    //     isMd ? 10 :
    //     isLg ? 8 :
    //     isSm ? 6 : 3;
    const maxImageSize = 
        isXl ? 180 :
        isMd ? 160 :
        isLg ? 140 :
        isSm ? 120 : 100;

    const images = useSelector(selectImages);
    const imageReview = useSelector(selectImageReview);

    useEffect(() => {
        dispatch(imagesSlice.actions.check(props.request));
            if(images.state.state == LoadState.NotStarted) {
                dispatch(retrieveImages(props.request));
            }
            if(imageReview.state.state == LoadState.Loaded) {
                setSelecting(false);
                setSelectedList([]);
            }
        }, [ dispatch, props.request, images.state.state, imageReview.state.state ]
    );

    const reviewPermissions = (props.request.targetType == ObjectTarget.SCHOOL)
        ? [ PermissionId.SCHOOL_ADMIN, PermissionId.SCHOOL_IMG_REVIEWER ]
        : [ PermissionId.CLASSROOM_ADMIN, PermissionId.CLASSROOM_IMG_REVIEWER ];
    const canReview = anyDirectPermission(user.priza.info, props.request.targetId, reviewPermissions);
    // console.log(`canReview = ${canReview}`);

    const retry = () => {
        dispatch(imagesSlice.actions.clean());
        setSelectedList([]);
    };

    const approve = () => {
        if(selectedList.length == 0) {
            return;
        }
        dispatch(performaImageReview({ status: 0, imageIds: selectedList }));
    };
    const reject = () => {
        if(selectedList.length == 0) {
            return;
        }
        dispatch(performaImageReview({ status: 1, imageIds: selectedList }));
    };

    if(isUpload) {
        return <Paper sx={{ width: "98%", m: "1%", minWidth: "300px" }} elevation={3}>
            <AppBar position="static" color={"primary"} sx={{ top: "auto", bottom: 0 }}>
                <Toolbar>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}> Inserir imagens </Typography>
                    <Box sx={{ flexGrow: 1 }} />
                </Toolbar>
            </AppBar>
            <ElementUploadImages
                target={{
                    schoolId: props.schoolId,
                    avatar: false,
                    objectTarget: props.request.targetType,
                    targetId: props.request.targetId,
                }}
                back={() => {
                    retry();
                    setIsUpload(false);
                }}
            />
        </Paper>;
    }

    const elToolbar = <AppBar position="static" color={"primary"} sx={{ top: "auto", bottom: 0 }}>
        <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}> {props.toolbar.label} </Typography>
            <Box sx={{ flexGrow: 1 }} />
            <ButtonGroup variant="contained" color="secondary">
                <Button key="selectingToggle"
                    color={selecting ? "success" : "secondary"}
                    disabled={!canReview}
                    onClick={(/* event */) => {{
                        setSelectedList([]);
                        setSelecting(!selecting); 
                    }}}> 
                    <Tooltip title="Selecionar imagens" >
                        <AddTaskIcon/>
                    </Tooltip>
                </Button>
                <Button key="reviewToggle"
                    color={reviewEnabled ? "success" : "secondary"}
                    disabled={selecting || !canReview}
                    onClick={(/* event */) => {{
                        setReviewEnabled(!reviewEnabled); 
                    }}}> 
                    <Tooltip title="Habilitar botões de aprovação" >
                        <RuleIcon/>
                    </Tooltip>
                </Button>
                <Button key="add" onClick={(/* event */) => {{
                        setIsUpload(true); 
                    }}}> 
                    <Tooltip title="Inserir imagem" >
                        <AddIcon/>
                    </Tooltip>
                </Button>
                <Button key="refresh" onClick={(/* event */) => { retry(); }}> 
                    <Tooltip title="Atualizar" >
                        <RefreshIcon/>
                    </Tooltip>
                </Button>
            </ButtonGroup>
        </Toolbar>
    </AppBar>;

    const formatDate = (date: string | undefined) => {
        const options: Intl.DateTimeFormatOptions = { weekday: "long", year: "numeric", month: "long", day: "2-digit" };
        return new Date(date || "2000-01-01" ).toLocaleDateString(undefined, options);
    };

    const onImageClick = (i: number, image: ImageInfo) => {
        if(selecting) {
            console.log(`Selecting image ${image.id} ...`);
            const index = selectedList.indexOf(image.id);
            if(index >= 0) {
                selectedList.splice(index, 1);
                setSelectedList([...selectedList]);
                return;
            } else {
                selectedList.push(image.id);
                setSelectedList([...selectedList]);
                return;
            }
        } else {
            setSelectedImage(i);
        }
    };

    const content = () => {
        if(!images.list || images.list.length == 0) {
            return <FragmentFullContent>
                <Typography variant="h6" component="div">
                    {props.messages.empty}
                </Typography>
            </FragmentFullContent>;
        }

        const elements = [] as React.ReactNode[];
        let lastDate = formatDate(images.list[0].createdAt);
        let imagesEl = [] as React.ReactNode[];
        for(let i = 0; i < images.list.length; i++) {
            const image = images.list[i];
            const thisDate = formatDate(image.createdAt);
            if( lastDate != thisDate ) {
                elements.push(
                    <Stack key={lastDate} direction="column" sx={{ pr: 2, pl: 2, mb: 2 }} >
                        <Typography variant="h6" sx={{backgroundColor: "#CCC", px: 2, fontFamily: "consolas"}} width="100%">
                            {lastDate}
                        </Typography>
                        {/* <ImageList variant="quilted" cols={columnCount} sx={{ p: 0, m: 0, mb: 2 }} gap={8}>
                            {imagesEl}
                        </ImageList> */}
                        <Grid container sx={{ /* backgroundColor: "#CCC" */ }} justifyContent="left" alignContent="left" textAlign="left">
                            {imagesEl}
                        </Grid>
                    </Stack>
                );
                imagesEl = [];
                lastDate = thisDate;
            }

            const selected = selectedList.indexOf(image.id) >= 0;
            imagesEl.push(
                <Box key={image.id} sx={{ mb: 1, mr: 1, position: "relative", cursor: "pointer" }} >
                    {
                        reviewEnabled && !selecting &&
                        <Stack direction="row" spacing={0} sx={{ position: "absolute", top: 0, left: 0, zIndex: 1 }}>
                            <Box 
                                onClick={(event) => {
                                    event.stopPropagation();
                                    dispatch(performaImageReview({ status: 0, imageIds: [image.id] }));
                                }}
                                sx={{ backgroundColor: "#00770077" }}
                                >
                                <IconButton sx={{ color: "#ffffff" }} size="small">
                                    <CheckIcon />
                                </IconButton>
                            </Box>
                            <Box 
                                onClick={(event) => {
                                    event.stopPropagation();
                                    dispatch(performaImageReview({ status: 1, imageIds: [image.id] }));
                                }}
                                sx={{ backgroundColor: "#77000077" }}
                                >
                                <IconButton sx={{ color: "#ffffff" }} size="small">
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                        </Stack>
                    }
                    <Stack>
                        { (selecting) &&
                            <Box sx={{ 
                                position: "absolute", 
                                margin: "3px", 
                                zIndex: 1, 
                                height: "24px", width: "24px",
                                color: selected ? "#00aa00cc" : "#ffffffcc", 
                                backgroundColor: selected ? "#ffffff80" : "#000000cc", 
                                borderRadius: "50%", opacity: 0.7 
                            }} >
                                { selected ? <CheckCircleIcon/> : <HighlightOffIcon/> }
                            </Box>
                        }
                        <Box sx={{ 
                            maxWidth: `${maxImageSize+4}px`, 
                            maxHeight: `${maxImageSize}px`,
                            borderLeft: "4px solid",
                            // borderBottom: "4px solid",
                            borderColor: getImageStatusColor(image.imageStatus),
                         }} >
                            <img 
                                src={`${getBackendThumbnailUrl(image)}`} 
                                alt={image.id} 
                                width={maxImageSize}
                                height={maxImageSize}
                                style={{ objectFit: "cover" }}
                                onClick={(/* event */) => onImageClick(i, image)}
                            />
                        </Box>
                    </Stack>
                </Box>
            );
        }

                        // <ImageListItem 
                        //     key={image.id} sx={{ maxHeight: maxImageSize, borderTop: "4px solid", borderColor: getImageStatusColor(image.imageStatus) }} >
                        //     <img src={`${getBackendThumbnailUrl(image)}`} alt={image.id} onClick={(/* event */) => onImageClick(i, image)}/>
                        // </ImageListItem>

        elements.push(
            <Stack key={lastDate} direction="column" sx={{ pr: 2, pl: 2 }} >
                <Typography variant="h6" sx={{backgroundColor: "#CCC", px: 2, fontFamily: "consolas"}} width="100%">
                    {lastDate}
                </Typography>
                <Grid container sx={{ /* backgroundColor: "#CCC" */ }} justifyContent="left" alignContent="left" textAlign="left">
                    {imagesEl}
                </Grid>

                {/* <ImageList variant="quilted" cols={columnCount} sx={{ p: 0, m: 0, mb: 2 }} gap={8}>
                    {imagesEl}
                </ImageList> */}
            </Stack>
        );

        const avatar: ImageSetAvatarRequest | undefined =
        selectedImage >= 0 && images.request ?
        {
            imageId: images.list[selectedImage].id,
            objectTarget: images.request.targetType,
            targetId: images.request.targetId
        } : undefined;
    
        return <Box key="show-images" sx={{mt: 2}}>
            {
                selecting &&
                <Box sx={{ mb: 2, mr: 3, ml: 3, p: 1, display: "flex", justifyContent: "center", gap: 2 }}>
                    <Button key="approve" variant="contained" color="success" onClick={(/* event */) => { approve(); }}> 
                        Aprovar
                    </Button>
                    <Button key="reject" variant="outlined" color="error" onClick={(/* event */) => { reject(); }}> 
                        Rejeitar
                    </Button>
                </Box>
            }
            {elements}
            <ModalImageDetail 
                open={ selectedImage >= 0 ? true : false } 
                close={() => setSelectedImage(-1)} 
                image={ selectedImage >= 0 ? images.list[selectedImage] : undefined } 
                avatar={avatar}
                next={ selectedImage < images.list.length - 1 ? () => setSelectedImage(selectedImage + 1) : undefined }
                previous={ selectedImage > 0 ? () => setSelectedImage(selectedImage - 1) : undefined }
                schoolId={props.schoolId}
                canDelete={props.canDelete}
            />
        </Box>;
    };

    return <Paper sx={{ width: "98%", m: "1%", minWidth: "300px" }} elevation={3}>
        {elToolbar}
        <Box width="100%">
            <CheckLoading
                states={[images.state]}
                error={props.messages.error}
                content={content}
                notStarted={props.notStarted}
                retry={retry} />
        </Box>
        <Backdrop
            sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
            open={ imageReview.state.state == LoadState.Loading }
            onClick={() => {console.log("Backdrop clicked");}} >
            <CircularProgress color="inherit" />
        </Backdrop>
    </Paper>;

}
